const IconNames = {
  "arrow-down": "\ue626",
  "chevron-down": "\ue60a",
  "chevron-left": "\ue609",
  "chevron-right": "\ue607",
  "chevron-small-down": "\ue61e",
  "chevron-small-left": "\ue61d",
  "chevron-small-right": "\ue61c",
  "chevron-small-up": "\ue61b",
  "chevron-up": "\ue606",
  "circle-chevron": "\ue630",
  "facebook-f": "\ue62d",
  "follow-circle.is-following": "\ue628",
  "follow-circle": "\ue629",
  "heart-small": "\ue622",
  "info-filled": "\ue605",
  "logo-unscaled": "\ue620",
  "logotype-unscaled": "\ue61f",
  "minus-small": "\ue623",
  "plus-small": "\ue602",
  "remove-small": "\ue621",
  "view-in-room": "\ue601",
  artwork: "\ue624",
  auction: "\ue60b",
  check: "\ue627",
  close: "\ue614",
  download: "\ue613",
  edit: "\ue612",
  ellipsis: "\ue610",
  facebook: "\ue618",
  follow: "\ue60f",
  frame: "\ue60e",
  grid: "\ue62e",
  heart: "\ue60d",
  info: "\ue604",
  instagram: "\ue62a",
  link: "\ue619",
  list: "\ue62f",
  logo: "\ue608",
  logotype: "\ue611",
  mail: "\ue603",
  person: "\ue61a",
  pinterest: "\ue617",
  search: "\ue62c",
  share: "\ue60c",
  tumblr: "\ue616",
  twitter: "\ue615",
  website: "\ue625",
  write: "\ue600",
}

export type IconName = keyof typeof IconNames

export default IconNames
